export default [
  {
    image: "la.png",
    hoverImage: "la_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=LAX&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'LosAngeles',
  },
  {
    image: "london.png",
    hoverImage: "london_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=LHR&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'London',
  },
  {
    image: "nagoya.png",
    hoverImage: "nagoya_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=NGO&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Nagoya',
  },

  {
    image: "hk.png",
    hoverImage: "hk_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=HKG&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'HongKong',
  },
  {
    image: "bangkok.png",
    hoverImage: "bangkok_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=BKK&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Bangkok',
  },
  {
    image: "bu.png",
    hoverImage: "bu_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=BNE&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Brisbane',
  },
  {
    image: "osaka.png",
    hoverImage: "osaka_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=KIX&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Osaka',
  },
  {
    image: "seatle.png",
    hoverImage: "seatle_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=SEA&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Seattle',
  },
  {
    image: "shanghai.png",
    hoverImage: "shanghai_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=PVG&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Shanghai',
  },
  {
    image: "suwu.png",
    hoverImage: "suwu_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=CEB&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Cebu',
  },
  {
    image: "macou.png",
    hoverImage: "macou_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=MFM&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Macao',
  },
  {
    image: "van.png",
    hoverImage: "van_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=YVR&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Vancouver',
  },
  {
    image: "kl.png",
    hoverImage: "kl_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=KUL&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'KualaLumpur',
  },
  {
    image: "okinawa.png",
    hoverImage: "okinawa_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=OKA&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Okinawa',
  },
  {
    image: "manila.png",
    hoverImage: "manila_.png",
    linkURL:
      "https://booking.evaair.com/flyeva/eva/b2c/booking-online.aspx?lang=zh-tw&gGoYYYYMM=&gGoDD=&gBackYYYYMM=&gBackDD=&gGoDep=TPE&gGoArr=MNL&gCabinClass=&utm_source=tw_website&utm_campaign=summer_sale&utm_content=fare",
    gaCat: 'Manila',
  }
]